import React from 'react';
import HeroSection from '../components/HeroSection';
import IntroSection from '../components/IntroSection';
import ClientsSection from '../components/ClientsSection';
import PresentationSection from '../components/PresentationSection';
import HalfCircularTimeline from '../components/HalfCircularTimeline';
import AchievementsSection from '../components/AchievementsSection';
import IntroSection2 from '../components/IntroSection2';
import LightingAspects from '../components/LightingAspects';


export default function HomePage() {
  return (
    // Use a <main> tag or a Fragment <> to group the components
    <main>
      <HeroSection />
      <IntroSection />
      
      {/* --- MOVED COMPONENTS --- */}
      <HalfCircularTimeline />
      {/* <UpcomingEvents /> */}
      
      {/* --- END OF MOVED COMPONENTS --- */}

      <ClientsSection />
      {/* <StatsSection /> */}
      <PresentationSection />
      {/* <CircularTimeline/> */}
      <AchievementsSection />
      <IntroSection2 />
      <LightingAspects />
    </main>
  );
}